// Constants for CCTV Dashboard

export const CCTV_COLORS = {
  primary: '#2c3e50',
  accent: '#3498db',
  active: '#27ae60',
  inactive: '#e74c3c',
  warning: '#f39c12',
  background: '#f8f9fa',
  cardBg: '#ffffff',
  border: '#dee2e6',
  text: '#212529',
  textMuted: '#6c757d',
};

export const POLLING_INTERVAL = 30000; // 30 seconds

// Status colors
export const getStatusColor = (status: 'active' | 'inactive'): string => {
  return status === 'active' ? CCTV_COLORS.active : CCTV_COLORS.inactive;
};

// Status label
export const getStatusLabel = (status: 'active' | 'inactive'): string => {
  return status === 'active' ? 'Active' : 'Inactive';
};
